import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=2cc43632&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc43632')) {
      api.createRecord('2cc43632', component.options)
    } else {
      api.reload('2cc43632', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=2cc43632&", function () {
      api.rerender('2cc43632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/Results/Card/Card.vue"
export default component.exports